import tableRenderPlugin from './table';
import treeRenderPlugin from './tree';
import treeSelectRenderPlugin from './treeSelect';

export {
  tableRenderPlugin,
  treeRenderPlugin,
  treeSelectRenderPlugin
};

export default [tableRenderPlugin, treeRenderPlugin, treeSelectRenderPlugin];
